import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"
import { Checkbox, transformLinkUri } from "gatsby-theme-gba"

const CheckboxEditable = ({ blok, visible }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Checkbox
      name={blok.name}
      label={
        <Markdown
          linkTarget="_blank"
          transformLinkUri={(uri) => {
            return transformLinkUri(uri, "", blok.currentLanguage)
          }}
        >
          {blok.label}
        </Markdown>
      }
      value={blok.value}
      placeholder={blok.placeholder}
      required={blok.required}
      visible={visible}
    />
  </div>
)

CheckboxEditable.defaultProps = {
  visible: true,
}

export default CheckboxEditable
